import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import * as React from 'react';
import { Control, Controller } from 'react-hook-form';

interface BuildComponent {
  name?: string;
  v?: any[];
  i?: { v: any; lbl: string }[];
}

interface CustomCheckBoxProps {
  buildComponent: BuildComponent;
  onChangeValue: (name: string, data: any[]) => void;
  control: Control<any>;
}

function applyCheckboxToggle(
  checked: boolean,
  itemValue: unknown,
  currentValues: unknown[] | undefined,
  setFieldValues: (next: unknown[]) => void,
  syncSelection: (next: unknown[]) => void,
) {
  if (checked) {
    const newValues = [itemValue, ...(currentValues || [])].filter((i) => !!i);
    setFieldValues(newValues);
    syncSelection(newValues);
    return;
  }
  const filteredValues = (currentValues || [])
    .filter((e) => e !== itemValue)
    .filter((i) => !!i);
  setFieldValues(filteredValues);
  syncSelection(filteredValues);
}

export const CustomCheckBox: React.FC<CustomCheckBoxProps> = ({ buildComponent, onChangeValue, control }) => {
  const onChange = (data: any[] = []) => {
    if (buildComponent?.name) {
      onChangeValue(buildComponent.name, data);
      buildComponent.v = data;
    }
  };

  return (
    <>
      {!!buildComponent?.name && (
        <Controller
          name={buildComponent.name}
          control={control}
          render={({ field }) => (
            <FormGroup>
              {buildComponent?.i?.map((item) => (
                <FormControlLabel
                  key={String(item.v)}
                  style={{ color: 'black' }}
                  control={
                    <Checkbox
                      value={item.v}
                      checked={buildComponent?.v?.includes(item.v)}
                      onChange={(_event, checked) =>
                        applyCheckboxToggle(checked, item.v, buildComponent.v, field.onChange, onChange)
                      }
                    />
                  }
                  label={item.lbl}
                />
              ))}
            </FormGroup>
          )}
        />
      )}
    </>
  );
};
